import { motion } from "framer-motion";

const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.95, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export default function PageHero({ eyebrow, titleLines, subtitle }) {
  return (
    <section className="relative overflow-hidden pb-16 pt-36 sm:pt-44">
      <div className="bg-grid-pattern pointer-events-none absolute inset-0 opacity-60" />
      <div className="animate-float-slow pointer-events-none absolute -top-24 right-[-10%] h-[420px] w-[420px] rounded-full bg-[#2997AB]/10 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        {eyebrow && (
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="font-plex text-xs uppercase tracking-[0.28em] text-[#1F8296]"
          >
            {eyebrow}
          </motion.p>
        )}
        <h1 className="text-balance mt-5 font-display text-4xl font-semibold leading-[1.06] tracking-tight text-[#1A2E33] sm:text-5xl lg:text-6xl">
          {titleLines.map((line, i) => (
            <MaskedLine key={i} delay={0.12 + i * 0.13}>
              {line}
            </MaskedLine>
          ))}
        </h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.5 }}
            className="mt-6 max-w-2xl text-base leading-relaxed text-[#5C7178] sm:text-lg"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
